export default __webpack_public_path__ + "static/media/sif-the-great-grey-wolf--front--240.7bcaf67a.jpg";